/** Shared layout tokens for Mestti OPS shell (list / chat / memories). */

/** Docked side panel width (Gemini-style) — pushes main SaaS content. */
export const OPS_DOCK_WIDTH_PX = 400;

/** Expanded (fullscreen) chat column — centered, readable line length. */
export const OPS_EXPANDED_CHAT_MAX_PX = 720;

/** Expanded mode: past-conversations sidebar on the left. */
export const OPS_EXPANDED_SIDEBAR_PX = 280;

/**
 * Inset around the docked/floating shell — matches TabManager strip padding (`py: 1` → 8px).
 * Top aligns with tab chips; right/bottom use the same gap.
 */
export const OPS_SHELL_GAP_PX = 8;

/**
 * Extra space between SaaS tabs/content and the chat left edge
 * so tabs never stick to the panel.
 */
export const OPS_CONTENT_GAP_PX = 16;

/** Total horizontal space the docked shell occupies (panel + right inset + content gap). */
export const OPS_DOCK_OUTER_PX =
  OPS_DOCK_WIDTH_PX + OPS_SHELL_GAP_PX + OPS_CONTENT_GAP_PX;

/** Compact floating overlays (legacy tokens; prefer in-panel views). */
export const OPS_PANEL_WIDTH = {
  xs: 'calc(100vw - 24px)',
  sm: '400px',
  md: '400px',
} as const;

export const OPS_PANEL_TOP = { xs: 72, sm: 92 } as const;

/** Above TabManager (modal+1…+4) so the dimmer covers the top chrome too. */
export const OPS_BACKDROP_Z = 1400;
export const OPS_SHELL_Z = 1410;

/** Placeholder title until Flash names the thread. */
export const NEW_THREAD_TITLE = 'Nova conversa';
